import { identity } from "../fp";
import { Reducer } from "../types";

export interface Mutation<TPayload = any> {
    type: string;
    payload?: TPayload;
}

export type MutationReducer<TValue> = Reducer<TValue, Mutation>;
export type MapArgsToPayload<TPayload> = (...args: any[]) => TPayload;

export const createMutatorApi = <TReturnValue, TValue>(
    returnValue: () => TReturnValue,
    reducer: MutationReducer<TValue>,
) => {
    const mutations: Mutation[] = [];
    const addMutation = <TPayload>(mutation: Mutation<TPayload>) => {
        mutations.push(mutation);
        return returnValue();
    };

    return {
        createMutator: <
            TPayload,
            TMapArgsToPayload extends MapArgsToPayload<
                TPayload
            > = MapArgsToPayload<TPayload>
        >(
            type: string,
            mapArgsToPayload = identity as TMapArgsToPayload,
        ) => (...args: Parameters<TMapArgsToPayload>) =>
            addMutation({ type, payload: mapArgsToPayload(...args) }),
        applyMutations: (initialValue: TValue): TValue =>
            mutations.reduce(reducer, initialValue),
    };
};
